import Calc from "@/common/util/calculator"
import Polygon from "./polygon"

export default abstract class Arrow extends Polygon {
  protected get baseRounding() {
    return 0
  }

  protected get cutlineRounding() {
    return this.signType == "aluminium_sign" ? this.printCutlineRounding(Calc.mmToPx(0.6)) : 0
  }
}
